module.exports = __webpack_public_path__ + "624c1255/img/38000000-5.b0f93d88.png";